import { useTranslations } from 'next-intl'
import styles from './GamepadModal.module.css'
import { useGamepadConnect } from '@/hooks/useGamepadConnect'
import GamepadLottie from '../../GamepadLottie/GamepadLottie'
import GamepadAnimation from '@/assets/videos/Gamepad-Mandatory_1.json'
export default function GamepadModal({ callback }: { callback: () => void}) {

    const t = useTranslations('Modals.Gamepad')

    useGamepadConnect({
        onConnect: () => {
            callback()
        }
    });

    return (
        <div className={styles.main} data-testid="Game_gamepadModal">
            <div className={styles.text}>
                <h2>{t('title')}</h2>
            </div>
            <GamepadLottie className={styles.lottie} animationData={GamepadAnimation} />
        </div>
    )
}